import { render, staticRenderFns } from "./LinkDownloadArquivoModelo.vue?vue&type=template&id=f01f0428&"
import script from "./LinkDownloadArquivoModelo.vue?vue&type=script&lang=js&"
export * from "./LinkDownloadArquivoModelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
